import RESTClient from 'web-app/api/clients/rest-client-famly-app';
import Plan from 'web-app/react/entities/plans/model';

export const createPlan = (plan, preview = false, options) => {
    return RESTClient.postAuthenticatedObservable(`v2/plans?preview=${preview}&version=2`, {plan}, options).map(
        response => ({
            plan: Plan.fromAPI(response.plan),
        }),
    );
};

export const updatePlan = (plan, oldId, preview = false, options) => {
    return RESTClient.putAuthenticatedObservable(`v2/plans/${oldId}?preview=${preview}&version=2`, {plan}, options).map(
        response => ({
            plan: Plan.fromAPI(response.plan),
        }),
    );
};

export const deletePlan = planId => {
    return RESTClient.deleteAuthenticatedObservable(`v2/plans/${planId}?version=2`);
};

export const deletePlanDryRun = planId => {
    return RESTClient.deleteAuthenticatedObservable(`v2/plans/${planId}?dryRun=true`);
};
